<template>
  <b-modal id="add-destinatario-ug-modal" size="lg" button-size="sm" centered header-bg-variant="secondary"
    header-text-variant="light" header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop no-close-on-esc>
    <template v-slot:modal-header="">
      <h5>Buscar Destinatários</h5>
    </template>
    <b-card no-body>
      <b-tabs @activate-tab="limparListaDestinatarios()" card>
        <b-tab title="Unidades Gestoras" ref="tabUgs" active>
          <b-card-body>
            <b-row>
              <b-col cols="12" lg="4">
                <b-form-group id="input-group-filtroNomeUg" label="Nome da UG" label-for="input-filtroNomeUg"
                  label-class="text-left">
                  <b-form-input id="input-filtroNomeUg" v-model="filtroUg.nome" type="text">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group id="input-group-filtroMunicipio" label="Município" label-for="input-filtroMunicipio"
                  label-class="text-left">
                  <b-form-input id="input-filtroMunicipio" v-model="filtroUg.municipio" type="text">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col id="input-group-filtroUg" cols="12" lg="6" xl="4">
                <span class="d-block text-left pb-1">Tipo de UG</span>
                <multiselect @input="updateFiltroTipoUg" v-model="tipoUgSelecionado" open-direction="bottom"
                  :close-on-select="false" :clear-on-select="false" deselect-label="" :allow-empty="true"
                  placeholder="Selecione os tipos..." track-by="Id" :options="tiposUg" label="Nome" :show-labels="false"
                  :multiple="true">
                  <template slot="selection" slot-scope="{ values }">
                    <span class="multiselect__single" v-if="values && values.length">
                      {{ values.length }} tipo(s) selecionado(s)
                    </span>
                  </template>
                  <template slot="noOptions">
                    <small><i>Erro ao obter dados.</i></small>
                  </template>
                  <template slot="noResult">
                    <i>Sem resultados.</i>
                  </template>
                </multiselect>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group id="input-group-filtroEsfera" label="Esfera" label-for="input-filtroEsfera"
                  label-class="text-left">
                  <b-form-select id="input-filtroEsfera" v-model="filtroUg.esfera"
                    :options="tiposEsfera"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group id="input-group-filtroArea" label="Área de controle e inspeção"
                  label-for="input-filtroArea" label-class="text-left">
                  <b-form-select id="input-filtroArea" v-model="filtroUg.area" :options="tiposArea"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4" class="float-center">
                <b-button class="mt-4" size="sm" variant="outline-secondary" @click="filtrarUgs()">
                  <font-awesome-icon icon="filter" class="mr-2" />
                  Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-tab>
        <b-tab title="Usuários" ref="tabUsuarios">
          <b-card-body>
            <b-row>
              <b-col cols="12">
                <b-form-group id="input-group-filtroNomeUsuario" label="Nome do usuário (pode ser só uma parte)"
                  label-for="input-filtroNomeUsuario" label-class="text-left">
                  <b-input-group>
                    <b-form-input id="input-filtroNomeUsuario" v-model="filtroUsuario.nome" type="text">
                    </b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="filtrarUsuarios()">
                        <font-awesome-icon icon="filter" class="mr-2" />
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-tab>
      </b-tabs>
    </b-card>
    <div v-if="destinatariosFiltrados && destinatariosFiltrados.length > 0" id="ugsTblWrapper">
      <b-button v-if="destinatariosSelecionados.length != destinatariosFiltrados.length"
        @click="$refs.tblDestinatarios.selectAllRows()" class="mb-1 mt-4" size="sm"
        variant="outline-secondary">Selecionar
        tudo</b-button>
      <b-button v-else @click="$refs.tblDestinatarios.clearSelected()" class="mb-1 mt-4" size="sm"
        variant="outline-secondary">Limpar seleção</b-button>
      <b-table :busy="isBusy" :fields="tipoDestinatario == 'ug'
      ? ugsFiltradasFields
      : usuariosFiltradosFields
      " hover no-border-collapse :items="destinatariosFiltrados" :sort-desc="true" striped small show-empty
        sticky-header select-mode="multi" selectable @row-selected="onRowSelected" ref="tblDestinatarios">
        <template #cell(selected)="{ rowSelected }">
          <div style="display: flex; justify-content: center">
            <span aria-hidden="true"><font-awesome-icon :icon="rowSelected ? 'check-square' : 'square'" /></span>
          </div>
        </template>
        <template #empty>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #table-busy>
          <div class="text-center text-dark">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="loading-text">Carregando...</strong>
          </div>
        </template>
      </b-table>
    </div>
    <template v-slot:modal-footer="">
      <b-button :disabled="!destinatariosSelecionados || destinatariosSelecionados.length < 1" size="sm"
        @click="adicionarDestinatarios()">
        Confirmar
      </b-button>
      <b-button size="sm" variant="outline-secondary" @click="fecharModalDestinatarios()">
        Cancelar
      </b-button>
    </template>
  </b-modal>
</template>

<script lang="ts">
import messagesService from "@/services/messagesService";
import Multiselect from "vue-multiselect";
import { Component, Vue } from 'vue-property-decorator'
import { UtilsTS } from '@/utilsts'
import { mixins } from 'vue-class-component'

const CompProps = Vue.extend({
  name: 'ModalSelecionarDestinatarios',
  components: { Multiselect },
  props: {
    idAviso: {
      type: Number,
      default: 0
    }
  }
})
@Component
export default class ModalSelecionarDestinatarios extends mixins(UtilsTS, CompProps) {
  filtroUg: any = {
    nome: null,
    municipio: null,
    tipoUg: [],
    esfera: null,
    area: null,
  }
  tipoUgSelecionado: any = null
  filtroUsuario: any = {
    nome: null,
  }
  tiposUg: any[] = []
  tiposEsfera: any[] = []
  tiposArea: any[] = []
  destinatariosFiltrados: any[] = []
  ugsFiltradasFields: any[] = [
    {
      key: "selected",
      label: "Selecionado",
      tdClass: "align-middle",
      thClass: "text-center",
      sortable: false,
    },
    {
      key: "Id",
      label: "Código",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: false,
    },
    {
      key: "Nome",
      label: "Nome",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
  ]
  usuariosFiltradosFields: any[] = [
    {
      key: "selected",
      label: "Selecionado",
      tdClass: "align-middle",
      thClass: "text-center",
      sortable: false,
    },
    {
      key: "Nome",
      label: "Nome",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: true,
    },
    {
      key: "Cpf",
      label: "Login (CPF)",
      tdClass: "align-middle",
      thClass: "align-center",
      sortable: false,
    },
    {
      key: "Id",
      label: "Código",
      tdClass: "d-none",
      thClass: "d-none",
      sortable: false,
    },
  ]
  destinatariosSelecionados: any[] = []
  isBusy = false
  tipoDestinatario = "ug"

  updateFiltroTipoUg(): void {
    this.filtroUg.tipoUg = this.tipoUgSelecionado.map((t) => t.Id);
  }

  limparFiltros(): void {
    this.filtroUg.nome = null;
    this.filtroUg.municipio = null;
    this.filtroUg.tipoUg = [];
    this.tipoUgSelecionado = null;
    this.filtroUg.esfera = null;
    this.filtroUg.area = null;
    this.filtroUsuario.nome = null;
  }

  fecharModalDestinatarios() {
    this.limparFiltros();
    this.destinatariosFiltrados = [];
    this.destinatariosSelecionados = [];
    this.$bvModal.hide("add-destinatario-ug-modal");
    this.$emit("fecharModalDestinatarios");
  }

  limparListaDestinatarios() {
    this.tipoDestinatario = this.tipoDestinatario == "ug" ? "usuario" : "ug";
    this.destinatariosFiltrados = [];
    this.destinatariosSelecionados = [];
  }

  async carregarTiposUg() {
    try {
      const response = await messagesService.getTiposUg()
      this.tiposUg = [{ Id: null, Nome: "TODOS" }, ...response.data];
    } catch (error) {
      this.tratarError(error);
    }
  }

  async carregarTiposEsferas() {
    try {
      const response = await messagesService.getEsferas()
      this.tiposEsfera = [
        { value: null, text: "Todas" },
        ...response.data.map((t) => {
          return {
            value: t.Id,
            text: t.Descricao,
          };
        }),
      ];
    } catch (error) {
      this.tratarError(error);
    }
  }

  async carregarAreasCI() {
    try {
      const response = await messagesService.getAreasCi()
      this.tiposArea = [
        { value: null, text: "Todas" },
        ...response.data.map((t) => {
          return {
            value: t.Id,
            text: t.Descricao,
          };
        }),
      ]
    } catch (error) {
      this.tratarError(error);
    }
  }

  async filtrarUgs() {
    try {
      this.isBusy = true;
      const response = await messagesService.filtrarUgs(
        this.filtroUg.nome,
        this.filtroUg.municipio,
        this.filtroUg.esfera,
        this.filtroUg.tipoUg,
        this.filtroUg.area
      )
      this.destinatariosFiltrados = response;
    } catch (error) {
      this.destinatariosFiltrados = [];
      this.tratarError(error);
    } finally {
      this.isBusy = false
    }
  }

  async filtrarUsuarios() {
    try {
      this.isBusy = true;
      const response = await messagesService.filtrarUsuarios(this.filtroUsuario.nome)
      this.destinatariosFiltrados = response.data;
    } catch (error) {
      this.tratarError(error);
    } finally {
      this.isBusy = false;
    }
  }

  async adicionarDestinatarios() {
    try {
      const idsDestinatarios = this.destinatariosSelecionados.map((d) => d.IdPCM ?? d.Id);
      const response = await messagesService.adicionarDestinatarios(
        this.idAviso,
        idsDestinatarios,
        this.tipoDestinatario
      );
      if (response && response.status == 200) {
        this.$emit('adicionouDestinatarios', this.idAviso)
        this.$toast.success("Destinatário(s) adicionado(s) com sucesso");
        this.fecharModalDestinatarios();
      } else {
        this.$toast.error("Erro ao adicionar destinatário");
      }
    } finally {
      this.isBusy = false;
    }
  }

  onRowSelected(items) {
    this.destinatariosSelecionados = items;
  }
  async mounted() {
    await this.carregarTiposUg();
    await this.carregarTiposEsferas();
    await this.carregarAreasCI();
    this.$bvModal.show("add-destinatario-ug-modal");
  }
}
</script>

<style>
#input-group-filtroUg .multiselect__option--selected {
  color: #fff !important;
  background: #a2a9af !important;
  font-weight: 400;
}
</style>